module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "overwrite-left"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    },
    slot: "overwrite-left"
  }, [_vm._v(" 关闭")]), _vm._v("\n    增加绑定\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('group', {
    staticStyle: {
      "margin": "0 0.1rem",
      "border-radius": "0.3rem"
    },
    attrs: {
      "label-width": "8em"
    }
  }, [_c('x-input', {
    attrs: {
      "label-width": "4em",
      "title": "http://",
      "placeholder": "请输入域名"
    },
    model: {
      value: (_vm.domain),
      callback: function($$v) {
        _vm.domain = $$v
      },
      expression: "domain"
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": "0.2rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d4b49ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostoperate/domainadd.vue
// module id = 6pZL
// module chunks = 1